<template>
    <div class="row justify-content-center">
        <div class="col-12 col-md-6" :class="logoType == 'ghost' ? '-logo' : ''">
            <img alt="Calls" src="../assets/icons/calls-blue.png" v-if="logoType == 'audio'">
            <img alt="Messages" src="../assets/icons/messages-blue.png" v-else-if="logoType == 'text'">
            <img alt="Videos" src="../assets/icons/videos-blue.png" v-else-if="logoType == 'video'">
            <img alt="Gallery" src="../assets/icons/gallery-blue.png" v-else-if="logoType == 'image'">
            <img alt="Ghost logo" src="../assets/logo.png" v-else>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        logoType : {
            default : 'ghost',
            type    : String
        }
    }
}
</script>